import { addClass } from "@kluntje/js-utils/lib/dom-helpers";
import { WECForm } from "Components/wec-m-form/wec-m-form";
import { LOADING } from "Constants/cssClasses";

import { RWDMailServiceParty, RWDMailServiceRequestOptions } from "./wec-m-contact-form.types";

export class WECContactForm extends WECForm {
  get toName(): string {
    return this.getAttribute("to-name") || "Werbung Christiansen";
  }

  get toMail(): string {
    return this.getAttribute("to-mail") || "frederik@riewerts.io";
  }

  get fromParty(): RWDMailServiceParty {
    const submitData = this.submitData;

    const name = submitData.find(item => item.name === "Name")?.value || "";
    const mail = submitData.find(item => item.name === "E-Mail")?.value || "";

    return {
      name,
      mail,
    };
  }

  get toParty(): RWDMailServiceParty {
    return {
      name: this.toName,
      mail: this.toMail,
    };
  }

  async postData() {
    const submitData = await this.getRequestOptions();

    if (submitData === null || this.submitUrl === "") return;

    this.renderLoadingBounce();
    addClass(this, LOADING);

    try {
      const response = await fetch(this.submitUrl, {
        method: "POST",
        body: JSON.stringify(submitData),
      });

      if (response.ok) {
        this.handleSuccess();
      } else {
        this.handleError(response.statusText);
      }
    } catch (e) {
      this.handleError(e);
    }
  }

  async getRequestOptions(): Promise<RWDMailServiceRequestOptions | null> {
    const mailTemplate = await this.loadMailTemplate();
    const body = mailTemplate({ data: this.submitData });
    const altBody = this.submitData.map(dataItem => `${dataItem.name}: ${dataItem.value}`).join("\n ");

    const fromParty = this.fromParty;

    if (fromParty.name === "" || fromParty.mail === "") return null;

    return {
      body,
      altBody,
      subject: "Nachricht von werbung-christiansen.de",
      from: fromParty,
      to: this.toParty,
      serviceId: "wec-website",
    };
  }

  async loadMailTemplate() {
    const { mailTemplate } = await import("./wec-m-contact-form__mail-template");
    return mailTemplate;
  }
}

customElements.define("wec-m-contact-form", WECContactForm);
